var React = require('react');

function IconCurrentLocation (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #404040;\n      }\n    ")),React.createElement("path",{"id":"icon-current-location","className":"cls-1","d":"M47.5,57.645A10.145,10.145,0,1,0,37.355,47.5,10.083,10.083,0,0,0,47.5,57.645Zm13-11.574h3v2.86h-3A13.168,13.168,0,0,1,48.93,60.5v3H46.07v-3A13.168,13.168,0,0,1,34.5,48.93h-3V46.07h3A13.168,13.168,0,0,1,46.07,34.5v-3h2.86v3A13.168,13.168,0,0,1,60.5,46.07Zm-13-4.357A5.787,5.787,0,1,1,41.713,47.5,5.782,5.782,0,0,1,47.5,41.713Z","transform":"translate(-31.5 -31.5)","key":1})]);
}

IconCurrentLocation.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = IconCurrentLocation;

IconCurrentLocation.default = IconCurrentLocation;
